import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ReservationDetailDto} from '../../domain/reservation/reservationDto';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FrontReservationHttpService {

    constructor(private http: HttpClient) {
    }

    public byId(reservationId): Observable<ReservationDetailDto> {
        return this.http.get<ReservationDetailDto>(`/v2/front/reservations/${reservationId}`);
    }
}
